export default __webpack_public_path__ + "static/media/CheckIcon.5416d349.webp";